import Api from '@/services/Api'
import axios from 'axios';

export default {
	async get(id) {
		return await axios.all([
			Api().get(process.env.VUE_APP_QUERY_URL_SHOWS + '/' + id),
			Api().get(process.env.VUE_APP_QUERY_URL_MODEL_SLIDES),
			Api().get(process.env.VUE_APP_QUERY_URL_WALL_SLIDES)
		])
			.then(axios.spread((show, modelSlides, wallSlides) => {
				show = show.data;
				modelSlides = modelSlides.data;
				wallSlides = wallSlides.data;

				for (let stepIndex in show.steps) {
					show.steps[stepIndex].model_slide =
						modelSlides.find(model_slide =>
							model_slide.id == show.steps[stepIndex].model_slide);

					show.steps[stepIndex].wall_slide =
						wallSlides.find(wall_slide =>
							wall_slide.id == show.steps[stepIndex].wall_slide);
				}

				return show;
			}));
	},
	async put(show) {
		await Api().put(process.env.VUE_APP_QUERY_URL_SHOWS + '/' + show.id, show)
			.then(function (response) {
				console.log('>>> show updated');
				console.log(response.data);
			})
			.catch(function (error) {
				console.log(error);
			})
	},
	async getAll() {
		return await Api().get(process.env.VUE_APP_QUERY_URL_SHOWS)
		.then(function (response) {
			return response.data;
		})
	},
	async create(show) {
		return await Api().post(process.env.VUE_APP_QUERY_URL_SHOWS, show)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			console.log(error);
		})
	},
	async delete(show) {
		Api().delete(process.env.VUE_APP_QUERY_URL_SHOWS + '/' + show.id)
		.then(function (response) {
			console.log('>>> show deleted');
			console.log(response);
		})
		.catch(function (error) {
			console.log(error);
		})
	}
}